import type { SVGProps } from "react"

const MTPFront = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <defs>
      <clipPath id="prefix__a">
        <path data-name="Rectangle 1439" fill="none" d="M0 0h350v350H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 3910" clipPath="url(#prefix__a)">
      <path
        data-name="Path 39077"
        d="M242.244 117.844a4.946 4.946 0 014.869 4.148h12.042a4.932 4.932 0 019.739 0h1.9a1.34 1.34 0 001.338-1.338v-6.115a1.34 1.34 0 00-1.338-1.337h-5.832a2.955 2.955 0 01-2.163-.947l-4.669-5.058a1.344 1.344 0 00-.984-.43h-13.13a1.335 1.335 0 00-1.178.7l-2.253 4.183a2.935 2.935 0 01-2.591 1.549h-2.521a1.339 1.339 0 00-1.338 1.338v6.114a1.339 1.339 0 001.338 1.338h1.9a4.946 4.946 0 014.869-4.148"
        fill="#fff"
      />
      <path
        data-name="Path 39078"
        d="M211.016 222.897h78.51V102.752a13.394 13.394 0 00-13.379-13.379H73.853a13.394 13.394 0 00-13.379 13.379v129.511a13.394 13.394 0 0013.379 13.379h118.354a19.109 19.109 0 0118.809-22.745m30.258-16.436c.1.1.185.217.286.319l-1.142 1.129c-.188-.192-.357-.4-.537-.6a4.766 4.766 0 01-1.733.336h-36.39a4.817 4.817 0 110-9.633h36.391a4.8 4.8 0 013.126 8.449m-39.518-43.77h36.391a4.817 4.817 0 110 9.633h-36.39a4.817 4.817 0 110-9.633m-4.817-8.028a4.822 4.822 0 014.817-4.817h36.391a4.817 4.817 0 110 9.633h-36.391a4.822 4.822 0 01-4.817-4.817m46.264 26.886l.882 1.342a15.562 15.562 0 00-2.372 1.916l-1.127-1.146a17.4 17.4 0 012.617-2.112m-6.381 7.645a17.193 17.193 0 011.61-2.952l1.327.9a15.545 15.545 0 00-1.459 2.676zm.572 3.535a15.724 15.724 0 00-.317 3.031l-1.605-.011a17.226 17.226 0 01.35-3.343zm8.565 18.932a17.163 17.163 0 01-2.956-1.6l.9-1.329a15.5 15.5 0 002.678 1.454zm.224-31.674a17.022 17.022 0 013.228-.947l.3 1.579a15.4 15.4 0 00-2.924.856zm6.334 33.009a17.358 17.358 0 01-3.342-.341l.318-1.574a15.679 15.679 0 003.032.31zm3.346-.311l-.305-1.576a15.393 15.393 0 002.92-.872l.609 1.487a17.127 17.127 0 01-3.224.961m-3.266-32.334v-1.605a17.26 17.26 0 013.345.326l-.311 1.574a15.657 15.657 0 00-3.033-.3m5.949 1.18l.614-1.482a17.138 17.138 0 012.964 1.589l-.895 1.334a15.43 15.43 0 00-2.683-1.441m3.512 28.617l-.888-1.338a15.783 15.783 0 002.363-1.926l1.13 1.139a17.312 17.312 0 01-2.605 2.125m1.526-25.239l1.137-1.132a17.19 17.19 0 012.131 2.6l-1.336.891a15.647 15.647 0 00-1.932-2.359m3.223 20.523l-1.332-.9a15.669 15.669 0 001.448-2.682l1.48.62a17.278 17.278 0 01-1.6 2.959m2.582-6.177l-1.573-.314a15.728 15.728 0 00.3-3.032h1.605a17.164 17.164 0 01-.334 3.344m-2.439-9.3l1.485-.612a17.182 17.182 0 01.97 3.221l-1.577.309a15.35 15.35 0 00-.878-2.918m-34.421-75.416a2.947 2.947 0 012.943-2.943h2.521a1.338 1.338 0 001.178-.7l2.253-4.183a2.94 2.94 0 012.591-1.549h13.13a2.952 2.952 0 012.163.947l4.669 5.057a1.345 1.345 0 00.984.431h5.832a2.946 2.946 0 012.943 2.942v6.115a2.947 2.947 0 01-2.943 2.943h-1.9a4.932 4.932 0 01-9.738 0h-12.039a4.932 4.932 0 01-9.738 0h-1.9a2.947 2.947 0 01-2.943-2.943zm-87.5-8.577h36.391a4.817 4.817 0 010 9.633h-36.386a4.817 4.817 0 110-9.633m0 12.844h66.361a4.817 4.817 0 010 9.633h-66.361a4.817 4.817 0 110-9.633m-65.826-7.492a5.358 5.358 0 015.352-5.352h38.532a5.358 5.358 0 015.352 5.352v23.547a5.358 5.358 0 01-5.352 5.352H84.557a5.358 5.358 0 01-5.352-5.352zm4.817 61.009h35.321a4.817 4.817 0 110 9.633H84.021a4.817 4.817 0 010-9.633m0 12.844h77.064a4.817 4.817 0 010 9.633H84.021a4.817 4.817 0 110-9.633m64.22 48.165h-23.547a4.817 4.817 0 110-9.633h23.547a4.817 4.817 0 010 9.633m0-25.688h-64.22a4.817 4.817 0 110-9.633h64.22a4.817 4.817 0 010 9.633m22.477 25.688h-5.352a4.817 4.817 0 010-9.633h5.352a4.817 4.817 0 010 9.633m13.914-25.688h-19.265a4.817 4.817 0 010-9.633h19.266a4.817 4.817 0 010 9.633m3.746-67.431h-43.884a4.282 4.282 0 010-8.563h43.884a4.282 4.282 0 010 8.563"
        fill="#fff"
      />
      <path
        data-name="Path 39079"
        d="M84.556 138.609h38.532a3.75 3.75 0 003.746-3.746v-23.548a3.75 3.75 0 00-3.746-3.746H84.556a3.75 3.75 0 00-3.746 3.746v23.547a3.75 3.75 0 003.746 3.746m19.266-25.153a9.633 9.633 0 11-9.633 9.633 9.645 9.645 0 019.633-9.633"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39080"
        d="M103.823 131.116a8.028 8.028 0 10-8.028-8.028 8.036 8.036 0 008.028 8.028"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39081"
        d="M84.557 140.214h38.532a5.358 5.358 0 005.352-5.352v-23.547a5.358 5.358 0 00-5.352-5.352H84.557a5.358 5.358 0 00-5.352 5.352v23.548a5.358 5.358 0 005.352 5.352m-3.746-28.9a3.75 3.75 0 013.746-3.746h38.532a3.75 3.75 0 013.746 3.746v23.548a3.75 3.75 0 01-3.746 3.746H84.557a3.75 3.75 0 01-3.746-3.746z"
        fill="#98a300"
      />
      <path
        data-name="Path 39082"
        d="M103.823 132.722a9.633 9.633 0 10-9.633-9.633 9.645 9.645 0 009.633 9.633m0-17.661a8.028 8.028 0 11-8.028 8.028 8.036 8.036 0 018.028-8.028"
        fill="#98a300"
      />
      <path
        data-name="Path 39083"
        d="M145.031 113.991h36.389a3.211 3.211 0 100-6.422h-36.389a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39084"
        d="M145.031 115.596h36.391a4.817 4.817 0 000-9.633h-36.391a4.817 4.817 0 000 9.633m0-8.028h36.391a3.211 3.211 0 110 6.422h-36.391a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39085"
        d="M84.021 180.351h35.321a3.211 3.211 0 100-6.422H84.021a3.211 3.211 0 000 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39086"
        d="M84.022 181.957h35.321a4.817 4.817 0 100-9.633H84.022a4.817 4.817 0 100 9.633m0-8.028h35.321a3.211 3.211 0 110 6.422H84.022a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39087"
        d="M188.38 133.257h-43.884a2.676 2.676 0 100 5.352h43.884a2.676 2.676 0 100-5.352"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39088"
        d="M188.379 131.651h-43.884a4.282 4.282 0 000 8.563h43.884a4.282 4.282 0 000-8.563m0 6.957h-43.884a2.676 2.676 0 110-5.352h43.884a2.676 2.676 0 110 5.352"
        fill="#98a300"
      />
      <path
        data-name="Path 39089"
        d="M148.241 199.618h-64.22a3.211 3.211 0 100 6.422h64.22a3.211 3.211 0 100-6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39090"
        d="M148.242 198.012h-64.22a4.817 4.817 0 100 9.633h64.22a4.817 4.817 0 100-9.633m0 8.028h-64.22a3.211 3.211 0 110-6.422h64.22a3.211 3.211 0 110 6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39091"
        d="M148.241 225.306h-23.547a3.211 3.211 0 000 6.422h23.547a3.211 3.211 0 100-6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39092"
        d="M148.242 223.7h-23.547a4.817 4.817 0 100 9.633h23.547a4.817 4.817 0 100-9.633m0 8.028h-23.547a3.211 3.211 0 010-6.422h23.547a3.211 3.211 0 110 6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39093"
        d="M184.633 199.618h-19.266a3.211 3.211 0 000 6.422h19.266a3.211 3.211 0 000-6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39094"
        d="M184.633 198.012h-19.267a4.817 4.817 0 000 9.633h19.266a4.817 4.817 0 100-9.633m0 8.028h-19.266a3.211 3.211 0 010-6.422h19.266a3.211 3.211 0 010 6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39095"
        d="M239.641 204.418c.187.284.4.553.606.826a3.2 3.2 0 00-2.1-5.622h-.6a15.292 15.292 0 00.665 2.1l-1.487.607a17.076 17.076 0 01-.827-2.707h-34.14a3.211 3.211 0 100 6.422h36.389a3.218 3.218 0 00.648-.066c-.165-.226-.342-.444-.5-.678z"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39096"
        d="M238.15 198.012h-36.391a4.817 4.817 0 100 9.633h36.391a4.786 4.786 0 001.733-.334c-.2-.219-.4-.427-.585-.654s-.333-.456-.5-.682a3.225 3.225 0 01-.648.064h-36.391a3.211 3.211 0 110-6.422h34.146c-.04-.172-.093-.344-.126-.517l1.486-.286.091-.016v.016c.051.272.128.535.195.8h.6a3.2 3.2 0 012.1 5.624c.162.213.324.423.5.628s.35.4.532.594a4.8 4.8 0 00-3.133-8.448"
        fill="#98a300"
      />
      <path
        data-name="Path 39097"
        d="M201.758 170.719h36.389a3.211 3.211 0 000-6.422h-36.389a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39098"
        d="M201.759 172.324h36.391a4.817 4.817 0 000-9.633h-36.391a4.817 4.817 0 100 9.633m0-8.028h36.391a3.211 3.211 0 010 6.422h-36.391a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39099"
        d="M201.758 157.875h36.389a3.211 3.211 0 000-6.422h-36.389a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39100"
        d="M201.759 159.48h36.391a4.817 4.817 0 000-9.633h-36.391a4.817 4.817 0 100 9.633m0-8.028h36.391a3.211 3.211 0 010 6.422h-36.391a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39101"
        d="M170.719 225.306h-5.352a3.211 3.211 0 000 6.422h5.352a3.211 3.211 0 000-6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39102"
        d="M170.718 223.7h-5.352a4.817 4.817 0 000 9.633h5.352a4.817 4.817 0 100-9.633m0 8.028h-5.352a3.211 3.211 0 010-6.422h5.352a3.211 3.211 0 010 6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39103"
        d="M145.031 126.835h66.361a3.211 3.211 0 000-6.422h-66.361a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39104"
        d="M145.031 128.44h66.361a4.817 4.817 0 000-9.633h-66.361a4.817 4.817 0 000 9.633m0-8.028h66.361a3.211 3.211 0 010 6.422h-66.361a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39105"
        d="M84.021 193.195h77.064a3.211 3.211 0 100-6.422H84.021a3.211 3.211 0 100 6.422"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39106"
        d="M84.022 194.8h77.064a4.817 4.817 0 100-9.633H84.022a4.817 4.817 0 100 9.633m0-8.028h77.064a3.211 3.211 0 110 6.422H84.022a3.211 3.211 0 110-6.422"
        fill="#98a300"
      />
      <path
        data-name="Path 39107"
        d="M319.228 242.053a17.572 17.572 0 00-17.552-17.552h-90.663a17.548 17.548 0 00-17.181 21.139c.057.272.137.535.207.8s.125.539.207.8a17.583 17.583 0 0016.767 12.367h90.66a17.571 17.571 0 0017.555-17.554m-45.572-1.375a3.058 3.058 0 012.723-1.626 2.817 2.817 0 011.361.313 2.7 2.7 0 01.94.76v-.964h1.385v6.638h-1.385v-.988a2.69 2.69 0 01-.838.71c-.041.022-.072.051-.113.074a2.966 2.966 0 01-2.56.046 3.049 3.049 0 01-.38-.166 3.215 3.215 0 01-1.132-1.23 3.862 3.862 0 01-.41-1.795 3.723 3.723 0 01.41-1.771m-4.576-1.518h1.373v.964a2.115 2.115 0 01.8-.783 2.365 2.365 0 011.192-.289v1.421h-.349a1.693 1.693 0 00-1.229.41 1.974 1.974 0 00-.41 1.421v3.494h-1.373v-6.638zm-5.05 0h.784v-1.65h1.385v1.65h1.613v1.121h-1.615v3.671a.744.744 0 00.169.543.923.923 0 00.6.156h.843v1.144h-1.084a2.581 2.581 0 01-.913-.158 1.606 1.606 0 01-.509-.275 1.789 1.789 0 01-.493-1.41v-3.67h-.784zm-2.629 4.241a6.437 6.437 0 00-1.121-.4 11.013 11.013 0 01-1.217-.4 2.2 2.2 0 01-.819-.59 1.567 1.567 0 01-.337-1.049 1.607 1.607 0 01.313-.963 2.079 2.079 0 01.892-.7 3.392 3.392 0 011.35-.253 2.732 2.732 0 011.82.578 2.03 2.03 0 01.747 1.554h-1.373a.978.978 0 00-.362-.711 1.354 1.354 0 00-.88-.265 1.423 1.423 0 00-.831.206.631.631 0 00-.29.542.589.589 0 00.193.446 1.487 1.487 0 00.47.289q.278.1.82.253a7.949 7.949 0 011.181.4 2.133 2.133 0 01.807.578 1.549 1.549 0 01.35 1.024 1.715 1.715 0 01-.314 1.011 2.07 2.07 0 01-.867.685.278.278 0 00-.025.014 3.249 3.249 0 01-1.337.254 3.479 3.479 0 01-1.381-.268c-.009 0-.019-.005-.029-.01a2.536 2.536 0 01-.976-.772 1.949 1.949 0 01-.385-1.1h1.421a.991.991 0 00.4.711 1.513 1.513 0 00.928.277 1.548 1.548 0 00.892-.217.682.682 0 00.325-.578.589.589 0 00-.362-.554m-9.547 2.239v-6.48h1.373v6.638h-1.373zm-.735-7.962l2.663-1.47v1.169l-2.663 1.313zm-7.089 1.482h1.373v.759a2.281 2.281 0 01.855-.638 2.788 2.788 0 011.121-.229 2.938 2.938 0 011.4.325 2.3 2.3 0 01.976.963 3.179 3.179 0 01.349 1.542v3.915h-1.361v-3.711a1.909 1.909 0 00-.445-1.361 1.578 1.578 0 00-1.217-.482 1.618 1.618 0 00-1.23.482 1.909 1.909 0 00-.445 1.361v3.711h-1.373v-6.638zm-8.214 1.518a3.059 3.059 0 012.735-1.626 3.019 3.019 0 011.277.289 2.56 2.56 0 011.013.747v-3.206h1.385v8.916h-1.385v-1a2.562 2.562 0 01-.94.8c-.039.02-.083.027-.123.046a2.891 2.891 0 01-1.238.268 3.04 3.04 0 01-1.2-.268 3 3 0 01-.386-.166 3.215 3.215 0 01-1.132-1.23 3.849 3.849 0 01-.41-1.795 3.71 3.71 0 01.41-1.771m-7.437 0a2.968 2.968 0 011.169-1.2 3.509 3.509 0 011.735-.422 3.385 3.385 0 011.675.409 2.9 2.9 0 011.144 1.157 3.434 3.434 0 01.41 1.7 4.307 4.307 0 01-.048.675h-5.072a1.84 1.84 0 00.59 1.277 1.865 1.865 0 001.3.482 1.607 1.607 0 001.566-.928h1.482a3.007 3.007 0 01-1.1 1.506 2.769 2.769 0 01-.563.311 3.5 3.5 0 01-1.389.268 3.539 3.539 0 01-1.319-.268 3.361 3.361 0 01-.393-.154 3.154 3.154 0 01-1.181-1.205 4.11 4.11 0 01-.012-3.6m-4.3-4.06l1.722 1.036 1.723-1.036v1.072l-1.723 1-1.722-1zm-.277 2.542h1.373v.964a2.115 2.115 0 01.8-.783 2.366 2.366 0 011.193-.289v1.421h-.35a1.7 1.7 0 00-1.229.41 1.978 1.978 0 00-.41 1.421v3.494h-1.373v-6.638zm-7.166-1.735h2.892a3.555 3.555 0 011.626.337 2.225 2.225 0 011 .892 2.427 2.427 0 01.337 1.265 2.537 2.537 0 01-.3 1.205 2.3 2.3 0 01-.964.928 3.639 3.639 0 01-1.7.349h-1.518v3.4h-1.373v-8.373zm71.3 8.373h-1.361v-3.711c0-.08-.025-.137-.03-.212a1.93 1.93 0 00-.272-.9 1.481 1.481 0 00-.143-.247 1.578 1.578 0 00-1.217-.482 1.615 1.615 0 00-1.229.482 1.9 1.9 0 00-.446 1.361v3.711h-1.373v-6.638h1.373v.759a2.281 2.281 0 01.855-.638 2.8 2.8 0 011.121-.229 2.938 2.938 0 011.4.325 2.294 2.294 0 01.573.423 2.412 2.412 0 01.4.541c.03.055.041.122.066.18a3.073 3.073 0 01.245 1c.011.122.037.232.037.363zm8.114 0h-1.386v-.988a2.719 2.719 0 01-.952.783 3.1 3.1 0 01-2.94-.12 3.231 3.231 0 01-1.132-1.23 3.862 3.862 0 01-.41-1.795 3.723 3.723 0 01.41-1.771 3.071 3.071 0 011.132-1.192 3.038 3.038 0 011.591-.433 2.817 2.817 0 011.361.313 2.689 2.689 0 01.94.76v-.964h1.386z"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39108"
        d="M293.646 240.512a1.983 1.983 0 00-2.723.759 2.383 2.383 0 00-.276 1.181 2.526 2.526 0 00.276 1.205 2.119 2.119 0 00.747.8 1.985 1.985 0 00.988.264 1.93 1.93 0 001.723-1.036 2.43 2.43 0 00.289-1.2 2.366 2.366 0 00-.289-1.193 1.936 1.936 0 00-.735-.771"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39109"
        d="M237.84 244.452a1.979 1.979 0 00.988.264 1.926 1.926 0 001.722-1.036 2.419 2.419 0 00.29-1.2 2.355 2.355 0 00-.29-1.193 1.97 1.97 0 00-3.457-.012 2.372 2.372 0 00-.277 1.181 2.513 2.513 0 00.277 1.205 2.111 2.111 0 00.747.8"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39110"
        d="M232.537 240.668a1.943 1.943 0 00-1.313-.458 1.751 1.751 0 00-1.217.458 1.866 1.866 0 00-.6 1.217h3.668a1.561 1.561 0 00-.542-1.217"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39111"
        d="M220.699 240.934a1.321 1.321 0 00.385-1.013q0-1.373-1.554-1.373h-1.519v2.735h1.515a1.7 1.7 0 001.169-.349"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39112"
        d="M275.68 244.452a1.982 1.982 0 00.988.264 1.93 1.93 0 001.723-1.036 2.43 2.43 0 00.289-1.2 2.366 2.366 0 00-.289-1.193 1.971 1.971 0 00-3.458-.012 2.372 2.372 0 00-.277 1.181 2.513 2.513 0 00.277 1.205 2.111 2.111 0 00.747.8"
        fill="#f2f5cc"
      />
      <path
        data-name="Path 39113"
        d="M301.676 222.897h-10.544V102.752a15 15 0 00-14.985-14.984H73.854a15 15 0 00-14.985 14.984v129.51a15 15 0 0014.985 14.985h118.739a19.177 19.177 0 0018.424 13.967h90.66a19.159 19.159 0 000-38.317m-90.66 36.711a17.585 17.585 0 01-16.768-12.361c-.081-.261-.137-.535-.207-.8s-.15-.529-.207-.8a17.548 17.548 0 0117.181-21.139h90.66a17.553 17.553 0 010 35.106zM73.854 245.642a13.393 13.393 0 01-13.379-13.379V102.752a13.394 13.394 0 0113.379-13.384h202.293a13.394 13.394 0 0113.379 13.379v120.15h-78.51a19.109 19.109 0 00-18.809 22.745z"
        fill="#98a300"
      />
      <path
        data-name="Path 39114"
        d="M294.67 240.126a2.689 2.689 0 00-.94-.76 2.817 2.817 0 00-1.361-.313 3.038 3.038 0 00-1.591.433 3.071 3.071 0 00-1.132 1.192 3.723 3.723 0 00-.41 1.771 3.862 3.862 0 00.41 1.795 3.232 3.232 0 001.132 1.23 3.1 3.1 0 002.94.12 2.719 2.719 0 00.952-.783v.988h1.386v-6.638h-1.386zm-.289 3.554a1.93 1.93 0 01-1.723 1.036 1.985 1.985 0 01-.988-.264 2.119 2.119 0 01-.747-.8 2.526 2.526 0 01-.276-1.205 2.383 2.383 0 01.276-1.181 1.96 1.96 0 013.458.012 2.366 2.366 0 01.289 1.193 2.43 2.43 0 01-.289 1.2"
        fill="#98a300"
      />
      <path
        data-name="Path 39115"
        d="M236.949 245.477a2.849 2.849 0 00.386.165 3.022 3.022 0 001.2.269 2.875 2.875 0 001.238-.269c.04-.018.085-.025.123-.045a2.562 2.562 0 00.94-.8v1h1.385v-8.916h-1.385v3.206a2.56 2.56 0 00-1.013-.747 3.019 3.019 0 00-1.277-.289 3.059 3.059 0 00-2.735 1.626 3.71 3.71 0 00-.41 1.771 3.849 3.849 0 00.41 1.795 3.215 3.215 0 001.132 1.23m.144-4.205a1.959 1.959 0 013.457.012 2.355 2.355 0 01.29 1.193 2.419 2.419 0 01-.29 1.2 1.926 1.926 0 01-1.722 1.036 1.979 1.979 0 01-.988-.264 2.111 2.111 0 01-.747-.8 2.513 2.513 0 01-.277-1.205 2.372 2.372 0 01.277-1.181"
        fill="#98a300"
      />
      <path
        data-name="Path 39116"
        d="M229.572 245.488a3.361 3.361 0 00.393.154 3.539 3.539 0 001.319.268 3.5 3.5 0 001.389-.268 2.769 2.769 0 00.563-.311 3.007 3.007 0 001.1-1.506h-1.482a1.607 1.607 0 01-1.566.928 1.865 1.865 0 01-1.3-.482 1.84 1.84 0 01-.59-1.277h5.072a4.307 4.307 0 00.048-.675 3.434 3.434 0 00-.41-1.7 2.9 2.9 0 00-1.144-1.157 3.385 3.385 0 00-1.675-.409 3.509 3.509 0 00-1.735.422 2.968 2.968 0 00-1.169 1.2 4.11 4.11 0 00.012 3.6 3.154 3.154 0 001.181 1.205m.435-4.82a1.751 1.751 0 011.217-.458 1.943 1.943 0 011.313.458 1.561 1.561 0 01.542 1.217h-3.674a1.866 1.866 0 01.6-1.217"
        fill="#98a300"
      />
      <path data-name="Path 39117" d="M253.782 236.21l-2.663 1.47v1.013l2.663-1.313z" fill="#98a300" />
      <path data-name="Path 39118" d="M227.525 237.692v-1.072l-1.723 1.036-1.722-1.036v1.072l1.722 1z" fill="#98a300" />
      <path
        data-name="Path 39119"
        d="M274.788 245.476a2.889 2.889 0 00.38.165 2.961 2.961 0 002.56-.045c.042-.022.073-.051.113-.074a2.69 2.69 0 00.838-.71v.988h1.385v-6.638h-1.385v.964a2.7 2.7 0 00-.94-.76 2.817 2.817 0 00-1.361-.313 3.058 3.058 0 00-2.723 1.626 3.723 3.723 0 00-.41 1.771 3.863 3.863 0 00.41 1.795 3.215 3.215 0 001.132 1.23m.145-4.205a1.96 1.96 0 013.458.012 2.366 2.366 0 01.289 1.193 2.43 2.43 0 01-.289 1.2 1.93 1.93 0 01-1.723 1.036 1.982 1.982 0 01-.988-.264 2.111 2.111 0 01-.747-.8 2.513 2.513 0 01-.277-1.205 2.372 2.372 0 01.277-1.181"
        fill="#98a300"
      />
      <path
        data-name="Path 39120"
        d="M264.814 243.958a1.789 1.789 0 00.493 1.41 1.606 1.606 0 00.509.275 2.581 2.581 0 00.913.158h1.084v-1.144h-.843a.923.923 0 01-.6-.156.744.744 0 01-.169-.543v-3.674h1.615v-1.121h-1.615v-1.655h-1.385v1.65h-.784v1.121h.784z"
        fill="#98a300"
      />
      <path
        data-name="Path 39121"
        d="M260.546 244.752a1.513 1.513 0 01-.928-.277.991.991 0 01-.4-.711h-1.421a1.949 1.949 0 00.385 1.1 2.536 2.536 0 00.976.772c.01 0 .02.005.029.01a3.479 3.479 0 001.381.268 3.249 3.249 0 001.337-.254.278.278 0 01.025-.014 2.064 2.064 0 00.867-.685 1.715 1.715 0 00.314-1.011 1.549 1.549 0 00-.35-1.024 2.133 2.133 0 00-.807-.578 7.949 7.949 0 00-1.181-.4q-.543-.156-.82-.253a1.487 1.487 0 01-.47-.289.589.589 0 01-.193-.446.631.631 0 01.29-.542 1.423 1.423 0 01.831-.206 1.354 1.354 0 01.88.265.978.978 0 01.362.711h1.373a2.03 2.03 0 00-.747-1.554 2.732 2.732 0 00-1.82-.578 3.392 3.392 0 00-1.35.253 2.079 2.079 0 00-.892.7 1.607 1.607 0 00-.313.963 1.567 1.567 0 00.337 1.049 2.2 2.2 0 00.819.59 11.013 11.013 0 001.217.4 6.437 6.437 0 011.121.4.589.589 0 01.362.554.682.682 0 01-.325.578 1.548 1.548 0 01-.892.217"
        fill="#98a300"
      />
      <path
        data-name="Path 39122"
        d="M287.659 240.522c-.026-.057-.037-.125-.066-.18a2.388 2.388 0 00-.4-.539 2.268 2.268 0 00-.572-.424 2.938 2.938 0 00-1.4-.325 2.8 2.8 0 00-1.121.229 2.281 2.281 0 00-.855.638v-.759h-1.373v6.638h1.373v-3.711a1.9 1.9 0 01.446-1.361 1.615 1.615 0 011.229-.482 1.578 1.578 0 011.217.482 1.556 1.556 0 01.143.247 1.942 1.942 0 01.272.9c.005.075.03.132.03.212v3.711h1.361v-3.915c0-.131-.027-.24-.037-.362a3.074 3.074 0 00-.245-1"
        fill="#98a300"
      />
      <path data-name="Path 39123" d="M253.227 245.641v-6.48h-1.377v6.638h1.373z" fill="#98a300" />
      <path
        data-name="Path 39124"
        d="M225.177 245.8v-3.491a1.978 1.978 0 01.41-1.421 1.7 1.7 0 011.229-.41h.35v-1.421a2.366 2.366 0 00-1.193.289 2.115 2.115 0 00-.8.783v-.964h-1.366v6.638z"
        fill="#98a300"
      />
      <path
        data-name="Path 39125"
        d="M270.453 245.8v-3.491a1.974 1.974 0 01.41-1.421 1.693 1.693 0 011.229-.41h.349v-1.421a2.365 2.365 0 00-1.192.289 2.115 2.115 0 00-.8.783v-.964h-1.367v6.638z"
        fill="#98a300"
      />
      <path
        data-name="Path 39126"
        d="M245.403 245.8v-3.711a1.909 1.909 0 01.445-1.361 1.618 1.618 0 011.23-.482 1.578 1.578 0 011.217.482 1.909 1.909 0 01.445 1.361v3.711h1.361v-3.915a3.179 3.179 0 00-.349-1.542 2.3 2.3 0 00-.976-.963 2.938 2.938 0 00-1.4-.325 2.788 2.788 0 00-1.121.229 2.281 2.281 0 00-.855.638v-.759h-1.373v6.638z"
        fill="#98a300"
      />
      <path
        data-name="Path 39127"
        d="M218.011 245.802v-3.4h1.519a3.639 3.639 0 001.7-.349 2.3 2.3 0 00.964-.928 2.537 2.537 0 00.3-1.205 2.427 2.427 0 00-.337-1.265 2.225 2.225 0 00-1-.892 3.555 3.555 0 00-1.626-.337h-2.895v8.376zm0-7.253h1.519q1.554 0 1.554 1.373a1.321 1.321 0 01-.385 1.013 1.7 1.7 0 01-1.169.349h-1.519z"
        fill="#98a300"
      />
      <path
        data-name="Path 39128"
        d="M235.474 123.598h1.9a4 4 0 010-1.605h-1.9a1.34 1.34 0 01-1.338-1.338v-6.114a1.34 1.34 0 011.338-1.338h2.521a2.935 2.935 0 002.591-1.549l2.253-4.183a1.337 1.337 0 011.178-.7h13.13a1.341 1.341 0 01.984.43l4.669 5.058a2.955 2.955 0 002.163.947h5.832a1.34 1.34 0 011.338 1.337v6.115a1.34 1.34 0 01-1.338 1.338h-1.9a4 4 0 010 1.605h1.9a2.947 2.947 0 002.943-2.943v-6.115a2.946 2.946 0 00-2.943-2.942h-5.832a1.345 1.345 0 01-.984-.431l-4.668-5.059a2.952 2.952 0 00-2.163-.947h-13.13a2.94 2.94 0 00-2.591 1.549l-2.253 4.183a1.338 1.338 0 01-1.178.7h-2.521a2.947 2.947 0 00-2.943 2.943v6.114a2.947 2.947 0 002.943 2.943"
        fill="#98a300"
      />
      <path data-name="Path 39129" d="M259.156 121.992h-12.042a4 4 0 010 1.605h12.042a4 4 0 010-1.605" fill="#98a300" />
      <path
        data-name="Path 39130"
        d="M242.244 119.45a3.393 3.393 0 103.237 2.542 3.345 3.345 0 00-3.237-2.542"
        fill="#fff"
      />
      <path
        data-name="Path 39131"
        d="M247.113 121.992a4.932 4.932 0 00-9.738 0 4 4 0 000 1.605 4.932 4.932 0 009.738 0 4 4 0 000-1.605m-1.524.8a3.393 3.393 0 11-.108-.8 3.315 3.315 0 01.108.8"
        fill="#98a300"
      />
      <path
        data-name="Path 39132"
        d="M264.025 119.45a3.393 3.393 0 103.237 2.542 3.345 3.345 0 00-3.237-2.542"
        fill="#fff"
      />
      <path
        data-name="Path 39133"
        d="M268.894 121.992a4.932 4.932 0 00-9.738 0 4 4 0 000 1.605 4.932 4.932 0 009.738 0 4 4 0 000-1.605m-1.524.8a3.393 3.393 0 11-.108-.8 3.315 3.315 0 01.108.8"
        fill="#98a300"
      />
      <path
        data-name="Path 39134"
        d="M262.126 181.638a17.069 17.069 0 00-2.965-1.588l-.614 1.481a15.583 15.583 0 012.684 1.441z"
        fill="#98a300"
      />
      <path
        data-name="Path 39135"
        d="M249.175 212.655a17.356 17.356 0 003.342.34l.009-1.605a15.686 15.686 0 01-3.032-.309z"
        fill="#98a300"
      />
      <path
        data-name="Path 39136"
        d="M255.944 179.073a17.261 17.261 0 00-3.345-.327v1.6a15.658 15.658 0 013.033.3z"
        fill="#98a300"
      />
      <path
        data-name="Path 39137"
        d="M255.56 211.11l.305 1.577a17.129 17.129 0 003.224-.962l-.608-1.486a15.456 15.456 0 01-2.921.871"
        fill="#98a300"
      />
      <path
        data-name="Path 39138"
        d="M261.172 208.81l.888 1.338a17.321 17.321 0 002.606-2.125l-1.131-1.14a15.724 15.724 0 01-2.363 1.927"
        fill="#98a300"
      />
      <path
        data-name="Path 39139"
        d="M269.406 192.565a17.206 17.206 0 00-.97-3.221l-1.485.612a15.428 15.428 0 01.878 2.918z"
        fill="#98a300"
      />
      <path
        data-name="Path 39140"
        d="M267.817 198.941l1.574.314a17.229 17.229 0 00.333-3.344h-1.605a15.644 15.644 0 01-.3 3.032"
        fill="#98a300"
      />
      <path
        data-name="Path 39141"
        d="M265.478 204.535l1.332.9a17.169 17.169 0 001.6-2.961l-1.479-.619a15.743 15.743 0 01-1.448 2.682"
        fill="#98a300"
      />
      <path
        data-name="Path 39142"
        d="M266.854 186.377a17.2 17.2 0 00-2.131-2.6l-1.138 1.133a15.658 15.658 0 011.933 2.359z"
        fill="#98a300"
      />
      <path
        data-name="Path 39143"
        d="M249.413 179.041a17.033 17.033 0 00-3.229.947l.6 1.488a15.413 15.413 0 012.923-.856z"
        fill="#98a300"
      />
      <path
        data-name="Path 39144"
        d="M241.716 184.807a15.562 15.562 0 012.372-1.916l-.882-1.342a17.342 17.342 0 00-2.617 2.113z"
        fill="#98a300"
      />
      <path
        data-name="Path 39145"
        d="M239.763 187.146l-1.327-.9a17.154 17.154 0 00-1.61 2.952l1.478.627a15.545 15.545 0 011.459-2.676"
        fill="#98a300"
      />
      <path
        data-name="Path 39146"
        d="M243.005 210.059a17.163 17.163 0 002.956 1.6l.623-1.48a15.421 15.421 0 01-2.678-1.452z"
        fill="#98a300"
      />
      <path
        data-name="Path 39147"
        d="M235.474 195.751l1.605.011a15.715 15.715 0 01.317-3.031l-1.572-.322a17.218 17.218 0 00-.35 3.343"
        fill="#98a300"
      />
      <path
        data-name="Path 39148"
        d="M238.218 201.718a15.353 15.353 0 01-.665-2.1c-.067-.268-.143-.532-.2-.8v-.018l-.09.018-1.486.284c.033.174.086.345.125.518a16.961 16.961 0 00.826 2.707z"
        fill="#98a300"
      />
      <path
        data-name="Path 39149"
        d="M240.247 205.24c-.207-.272-.419-.542-.606-.826l-1.34.882c.154.233.331.452.5.678s.322.463.5.683.39.436.585.653c.18.2.348.409.537.6l1.141-1.129c-.1-.1-.187-.214-.285-.318-.182-.195-.361-.392-.532-.594s-.336-.415-.5-.628"
        fill="#98a300"
      />
    </g>
  </svg>
)
export { MTPFront }
